import { useQuery } from '@tanstack/react-query';
import { keys } from '@/lib/queryKeys';
import { fetchPrescriptionDetail } from './api';

/** Full item list — with per-item dispensed/remaining quantity — for the prescription currently selected on the Dispensing screen. */
export function usePrescriptionDetail(id: number | null) {
  return useQuery({
    queryKey: keys.prescriptions.detail(id ?? -1),
    queryFn: () => fetchPrescriptionDetail(id as number),
    enabled: id != null,
  });
}
